module.exports = __webpack_public_path__ + "static/media/behance-square.4048a26e.svg";